import * as types from '../actions/_actionTypes';
import initialState from './_initialReducerState'

export default function InvoicerefsReducer(state = initialState.invoicerefs, action: any) {
  switch (action.type) {
    case types.SAVE_INVOICEREFS_SUCCESS:
      return action.invoicerefs;
    default:
      return state;
  }
}
